const escapeHtml = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

const inline = (text) => escapeHtml(text)
  .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
  .replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>')
  .replace(/`([^`\n]+)`/g, '<code>$1</code>')
  .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*|mailto:[^\s)]+)\)/g, (m, label, href) => {
    const external = href.startsWith('http');
    return `<a href="${href}"${external ? ' target="_blank" rel="noopener noreferrer"' : ''}>${label}</a>`;
  })
  .replace(/(^|[\s(])((?:[\w.+-]+)@(?:[\w-]+\.)+[a-z]{2,})/gi, '$1<a href="mailto:$2">$2</a>');

// Minimal, safe Markdown → HTML (headings, bold/italic, links, lists, paragraphs)
export const renderMarkdown = (md = '') => {
  const lines = md.replace(/\r\n/g, '\n').split('\n');
  const out = [];
  let list = null;
  let para = [];
  let table = null;

  const flushPara = () => {
    if (para.length) { out.push(`<p>${para.map(inline).join('<br/>')}</p>`); para = []; }
  };
  const flushList = () => {
    if (list) { out.push(`<${list.tag}>${list.items.map(i => `<li>${inline(i)}</li>`).join('')}</${list.tag}>`); list = null; }
  };
  const flushTable = () => {
    if (!table) return;
    const [head, ...body] = table;
    out.push(`<div class="md-table"><table><thead><tr>${head.map(c => `<th>${inline(c)}</th>`).join('')}</tr></thead><tbody>${body.map(r => `<tr>${r.map(c => `<td>${inline(c)}</td>`).join('')}</tr>`).join('')}</tbody></table></div>`);
    table = null;
  };
  const cells = (line) => line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map(c => c.trim());

  for (const raw of lines) {
    const line = raw.trimEnd();
    const heading = line.match(/^(#{1,4})\s+(.*)$/);
    const ul = line.match(/^\s*[-*]\s+(.*)$/);
    const ol = line.match(/^\s*\d+[.)]\s+(.*)$/);
    if (/^\s*\|.*\|\s*$/.test(line)) {
      flushPara(); flushList();
      if (/^\s*\|?\s*:?-{2,}/.test(line)) continue;
      (table = table || []).push(cells(line));
      continue;
    }
    flushTable();
    if (!line.trim()) { flushPara(); flushList(); continue; }
    if (heading) {
      flushPara(); flushList();
      const level = Math.min(heading[1].length + 1, 5);
      out.push(`<h${level}>${inline(heading[2])}</h${level}>`);
      continue;
    }
    if (ul || ol) {
      flushPara();
      const tag = ul ? 'ul' : 'ol';
      if (!list || list.tag !== tag) { flushList(); list = { tag, items: [] }; }
      list.items.push((ul || ol)[1]);
      continue;
    }
    if (line.trim() === '---') { flushPara(); flushList(); out.push('<hr/>'); continue; }
    flushList();
    para.push(line.trim());
  }
  flushPara(); flushList(); flushTable();
  return out.join('\n');
};
